import { AgendamentoProvider } from '$providers/agendamento';
import { ViewProvider } from '$providers/view';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { AgendamentoFormPage } from '../agendamento-form/agendamento-form';

@Component({
  selector: 'page-agendamento-list',
  templateUrl: 'agendamento-list.html',
})
export class AgendamentoListPage {

  agendamentos: Array<any> = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, private view: ViewProvider, private agendamentoProvider: AgendamentoProvider) {
  }

  ionViewDidEnter() {
    this.agendamentoProvider.buscarAgedamentos().subscribe(
      (dados) => this.agendamentos = dados.agendamentos,
      (err) => console.error(err));
  }

  adicionar() {
    this.navCtrl.push(AgendamentoFormPage);
  }

  cancelar(agendamento) {
    this.view.showConfirm("Deseja realmente cancelar o seu agendamento para o dia <b>" + agendamento.horario + "</b>?",
      () => {
        this.agendamentoProvider.cancelar(agendamento.id).subscribe(
          (dados) => {
            this.view.showMessage(dados.mensagem);
            this.ionViewDidEnter();
          },
          (err) => console.error(err))
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/agendamento/agendamento-list/agendamento-list.ts